import { Provider } from '@angular/core';
import { NoDataComponent } from './no-data/no-data.component';
import { BaseComponent } from './base/base.component';
import { LoadingComponent } from './loading/loading.component';
import { TableSearchComponent } from './table-search/table-search.component';
import { SharedInputComponent } from './shared-input/shared-input.component';
import { AiChatComponent } from './ai-chat/ai-chat.component';

export * from './no-data/no-data.component';
export * from './base/base.component';
export * from './loading/loading.component';
export * from './table-search/table-search.component';
export * from './shared-input/shared-input.component';
export * from './ai-chat/ai-chat.component';
export * from './ai-chat/ai-chat.service';

export const COMMON_COMPONENTS: Provider[] = [
  LoadingComponent,
  NoDataComponent,
  BaseComponent,
  TableSearchComponent,
  SharedInputComponent,
  AiChatComponent,
];

